import React from 'react';
import { Icon } from '@ui-library';
import { IconName } from '../Icon/Icon.type';
import { Message } from '../../types/chat';

interface RollbackMarkerProps {
  message: Message;
  onViewOriginalChat?: (parentSegmentId: string) => void;
}

const RollbackMarker: React.FC<RollbackMarkerProps> = ({
  message,
  onViewOriginalChat,
}) => {
  const parentSegmentId = message.parentSegmentId;

  return (
    <div className="my-4 mx-4">
      <div className="border-t border-dashed border-border-secondary mb-4" />
      <div className="flex flex-col gap-1 px-4 py-3 rounded-lg bg-bg-secondary border border-border-secondary">
        <div className="flex items-start gap-3">
          <div className="flex items-center justify-center w-6 h-6 rounded-full bg-bg-tertiary flex-shrink-0 mt-0.5 text-text-tertiary">
            <Icon name={IconName.Revert} size="sm" inheritColor />
          </div>
          <div className="flex flex-col gap-0.5">
            <span className="text-sm text-text-primary">
              {message.content}
            </span>
            <div className="flex items-center gap-2 text-xs text-text-tertiary">
              {onViewOriginalChat && parentSegmentId && (
                <>
                  <button
                    onClick={() => onViewOriginalChat(parentSegmentId)}
                    className="text-text-brand-primary hover:underline cursor-pointer"
                  >
                    View original chat
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RollbackMarker;
